// extracted by mini-css-extract-plugin
export default {"container":"AvatarFormItem_container__9T5Nh","image":"AvatarFormItem_image__Gggwr","inner":"AvatarFormItem_inner__l5bue","plus":"AvatarFormItem_plus__p7fQP"};